import { Utilities } from "shared/utilities";
import { ProcessTemplateAppState, UsedInModalState } from "../model/AppState";
import { ProcessTemplate, ProcessTemplateImport } from "processTemplates/model/ProcessTemplate";
import { MissingTask } from "processTemplates/model/MissingTask";

export const SET_LOADING = "SET_LOADING";
export const SET_PROCESS_TEMPLATES = "SET_PROCESS_TEMPLATES";
export const SET_PROCESS_TEMPLATES_COUNT = "SET_PROCESS_TEMPLATES_COUNT";
export const SET_AVAILABLE_TAGS = "SET_AVAILABLE_TAGS";
export const SET_IMPORT_MODAL_OPEN = "SET_IMPORT_MODAL_OPEN";
export const SET_CONFIRM_PROCESS_UPDATES_FOR_TEMPLATE_IMPORT = "SET_CONFIRM_PROCESS_UPDATES_FOR_TEMPLATE_IMPORT";
export const SET_EDITED_TEMPLATE = "SET_EDITED_TEMPLATE";
export const SET_TEMPLATE_FOR_CREATE = "SET_TEMPLATE_FOR_CREATE";
export const SET_VIEW_CHANGE_LOG_FOR_TEMPLATE_ID = "SET_VIEW_CHANGE_LOG_FOR_TEMPLATE_ID";
export const SET_USED_IN_MODAL_OPEN = "SET_USED_IN_MODAL_OPEN";
export const SET_SWITCH_VERSION_FOR_TEMPLATE_ID = "SET_SWITCH_VERSION_FOR_TEMPLATE_ID";
export const SET_DELETED_TEMPLATE_IDS = "SET_DELETED_TEMPLATE_IDS";
export const SET_TAGGED_TEMPLATE_IDS = "SET_TAGGED_TEMPLATE_IDS";
export const SET_SELECTED_TEMPLATE_IDS = "SET_SELECTED_TEMPLATE_IDS";
export const SET_MISSING_TASKS = "SET_MISSING_TASKS";

export const processTemplateInitialState: ProcessTemplateAppState = {
    loading: true,
    processTemplates: undefined,
    processTemplatesCount: undefined,
    availableTags: [],
    importModalOpen: false,
    confirmProcessUpdatesForTemplateImport: undefined,
    editedTemplate: undefined,
    templateForCreate: undefined,
    viewChangeLogForTemplateId: undefined,
    usedInModalState: undefined,
    switchVersionForTemplateId: undefined,
    deletedTemplateIds: undefined,
    taggedTemplateIds: undefined,
    selectedTemplateIds: [],
    userPermissions: Utilities.getAllUserPermissions(),
    missingTasks: [],
};

export type ProcessTemplateAppReducerAction =
    | { type: typeof SET_LOADING, loading: boolean }
    | { type: typeof SET_PROCESS_TEMPLATES, processTemplates?: ProcessTemplate[] }
    | { type: typeof SET_PROCESS_TEMPLATES_COUNT, processTemplatesCount?: number }
    | { type: typeof SET_AVAILABLE_TAGS, availableTags: string[] }
    | { type: typeof SET_IMPORT_MODAL_OPEN, open: boolean }
    | { type: typeof SET_CONFIRM_PROCESS_UPDATES_FOR_TEMPLATE_IMPORT, confirmProcessUpdatesForTemplateImport?: ProcessTemplateImport }
    | { type: typeof SET_EDITED_TEMPLATE, editedTemplate?: ProcessTemplate }
    | { type: typeof SET_TEMPLATE_FOR_CREATE, templateForCreate?: ProcessTemplate }
    | { type: typeof SET_VIEW_CHANGE_LOG_FOR_TEMPLATE_ID, viewChangeLogForTemplateId?: number }
    | { type: typeof SET_USED_IN_MODAL_OPEN, usedInModalState?: UsedInModalState }
    | { type: typeof SET_SWITCH_VERSION_FOR_TEMPLATE_ID, switchVersionForTemplateId?: number }
    | { type: typeof SET_DELETED_TEMPLATE_IDS, deletedTemplateIds?: number[] }
    | { type: typeof SET_TAGGED_TEMPLATE_IDS, taggedTemplateIds?: number[] }
    | { type: typeof SET_SELECTED_TEMPLATE_IDS, selectedTemplateIds: number[] }
    | { type: typeof SET_MISSING_TASKS, missingTasks: MissingTask[] }


export function processTemplateAppReducer(state: ProcessTemplateAppState, action: ProcessTemplateAppReducerAction) {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_PROCESS_TEMPLATES:
            return {
                ...state,
                processTemplates: action.processTemplates
            };
            case SET_PROCESS_TEMPLATES_COUNT:
                return {
                    ...state,
                    processTemplatesCount: action.processTemplatesCount
                };
        case SET_AVAILABLE_TAGS:
            return {
                ...state,
                availableTags: action.availableTags
            };
        case SET_IMPORT_MODAL_OPEN:
            return {
                ...state,
                importModalOpen: action.open
            };
        case SET_CONFIRM_PROCESS_UPDATES_FOR_TEMPLATE_IMPORT:
            return {
                ...state,
                confirmProcessUpdatesForTemplateImport: action.confirmProcessUpdatesForTemplateImport
            };
        case SET_EDITED_TEMPLATE:
            return {
                ...state,
                editedTemplate: action.editedTemplate
            };
        case SET_TEMPLATE_FOR_CREATE:
            return {
                ...state,
                templateForCreate: action.templateForCreate
            };
        case SET_VIEW_CHANGE_LOG_FOR_TEMPLATE_ID:
            return {
                ...state,
                viewChangeLogForTemplateId: action.viewChangeLogForTemplateId
            };
        case SET_USED_IN_MODAL_OPEN:
            return {
                ...state,
                usedInModalState: action.usedInModalState
            };
        case SET_SWITCH_VERSION_FOR_TEMPLATE_ID:
            return {
                ...state,
                switchVersionForTemplateId: action.switchVersionForTemplateId
            };
        case SET_DELETED_TEMPLATE_IDS:
            return {
                ...state,
                deletedTemplateIds: action.deletedTemplateIds
            };
        case SET_TAGGED_TEMPLATE_IDS:
            return {
                ...state,
                taggedTemplateIds: action.taggedTemplateIds
            };
        case SET_SELECTED_TEMPLATE_IDS:
            return {
                ...state,
                selectedTemplateIds: action.selectedTemplateIds
            };
        case SET_MISSING_TASKS:
            return {
                ...state,
                missingTasks: action.missingTasks
            }
        default:
            return processTemplateInitialState;
    }
}